/*
 * @Author: 李文敬
 * @version: 1.0.0
 * @Company: 和顺旭基(深圳)中医药科技有限公司
 * @Description: 加密方法
 * @Date: 2021-06-21 09:10:39
 * @LastEditors: 李文敬
 * @LastEditTime: 2022-08-03 11:28:05
 */
// const CryptoJS = require('crypto-js') // 引用AES源码js
import CryptoJS from 'crypto-js'
import { LocPrefix } from '@/config'

const key = CryptoJS.enc.Utf8.parse('641a46e8-db10-20d7-6832-3eef9a5658d3') // 密钥
const iv = CryptoJS.enc.Utf8.parse('5ba053e3-1c1b-320b-4ada-0adb1a5f868f') // 密钥偏移量

// 加密方法
export function Encrypt(word) {
  if (!word) {
    return ''
  }
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString().toUpperCase()
}

// 解密方法
export function Decrypt(word) {
  try {
    if (!word) {
      return ''
    }
    const encryptedHexStr = CryptoJS.enc.Hex.parse(word)
    const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
    const decrypt = CryptoJS.AES.decrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
  } catch (err) {
    for (const key in localStorage) {
      if (key.indexOf(LocPrefix) !== -1) {
        localStorage.removeItem(key)
      }
    }
    location.reload()
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/secret.js